/**
 * 动态更新页面meta信息
 * @param {Object} meta - 路由meta对象
 */
export function updateMetaTags(meta) {
  // 更新页面标题
  if (meta.title) {
    document.title = meta.title;
  }

  // 更新或创建description meta标签
  updateOrCreateMetaTag('description', meta.description);
  
  // 更新或创建keywords meta标签
  updateOrCreateMetaTag('keywords', meta.keywords);
  
  // 更新或创建og:title meta标签
  updateOrCreateMetaProperty('og:title', meta.title);
  
  // 更新或创建og:description meta标签
  updateOrCreateMetaProperty('og:description', meta.description);
  
  // 更新或创建og:image meta标签
  if (meta.ogImage) {
    updateOrCreateMetaProperty('og:image', meta.ogImage);
  }
  
  // 更新或创建logo link标签
  if (meta.logo) {
    updateOrCreateLinkTag('logo', meta.logo);
  }
  
  // 更新或创建icon link标签
  if (meta.icon) {
    updateOrCreateLinkTag('icon', meta.icon);
  }
}

/**
 * 更新或创建meta标签
 * @param {string} name - meta标签的name属性
 * @param {string} content - meta标签的content属性
 */
function updateOrCreateMetaTag(name, content) {
  if (!content) return;
  
  let metaTag = document.querySelector(`meta[name="${name}"]`);
  
  if (metaTag) {
    metaTag.setAttribute('content', content);
  } else {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', content);
    document.head.appendChild(metaTag);
  }
}

/**
 * 更新或创建meta property标签（用于Open Graph）
 * @param {string} property - meta标签的property属性
 * @param {string} content - meta标签的content属性
 */
function updateOrCreateMetaProperty(property, content) {
  if (!content) return;
  
  let metaTag = document.querySelector(`meta[property="${property}"]`);
  
  if (metaTag) {
    metaTag.setAttribute('content', content);
  } else {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('property', property);
    metaTag.setAttribute('content', content);
    document.head.appendChild(metaTag);
  }
}

/**
 * 更新或创建link标签
 * @param {string} rel - link标签的rel属性
 * @param {string} href - link标签的href属性
 */
function updateOrCreateLinkTag(rel, href) {
  if (!href) return;
  
  let linkTag = document.querySelector(`link[rel="${rel}"]`);
  
  if (linkTag) {
    linkTag.setAttribute('href', href);
  } else {
    linkTag = document.createElement('link');
    linkTag.setAttribute('rel', rel);
    linkTag.setAttribute('href', href);
    document.head.appendChild(linkTag);
  }
}